module.exports = __webpack_public_path__ + "static/logo-mobile-70dafea82312cfb5bc561292122a00ad.png";